// extracted by mini-css-extract-plugin
export default {"iconBox":"zPaPnB9_VXPEKyv8jbqr","inputBox":"Hdgy5pZ0PuWrzX22bLH_"};